// shared/tiers — secret: IP formula, tier-gating predicates, enchant arithmetic.

import { z } from 'zod';
import {
  IP_TIER_COEFFICIENT,
  IP_ENCHANT_COEFFICIENT,
  QUALITY_BONUS,
  MIN_TIER,
  MAX_TIER,
  MIN_ENCHANT,
  MAX_ENCHANT,
} from './data.js';

export const TierSchema = z.number().int().min(MIN_TIER).max(MAX_TIER);
export const EnchantSchema = z.number().int().min(MIN_ENCHANT).max(MAX_ENCHANT);
export const QualitySchema = z.enum([
  'Normal',
  'Good',
  'Outstanding',
  'Excellent',
  'Masterpiece',
]);

export type Tier = z.infer<typeof TierSchema>;
export type Enchant = z.infer<typeof EnchantSchema>;
export type Quality = z.infer<typeof QualitySchema>;

export function computeIP(tier: Tier, enchant: Enchant, quality: Quality): number {
  return tier * IP_TIER_COEFFICIENT + enchant * IP_ENCHANT_COEFFICIENT + QUALITY_BONUS[quality];
}

export function canGather(toolTier: Tier, nodeTier: Tier): boolean {
  return toolTier >= nodeTier;
}

export function canCraft(stationTier: Tier, recipeTier: Tier): boolean {
  return stationTier >= recipeTier;
}

export function formatTier(tier: Tier, enchant: Enchant): string {
  return `T${tier}.${enchant}`;
}
